/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Button, FormAlert, Input } from '@components';
import { verifyEmail } from '@apis/Auth';

import sty from '@flow/AuthWrapper/auth.module.scss';

// how many required field
const TOTAL_FIELD = 1;

export default function EmailForm({ handleFormType, handleDataObj, setLoading, value }) {
  const [isFormPristine, handleFormPristine] = useState(true);
  const [loading, handleLoading] = useState(false);

  // for form submission
  const [hasError, handleHasError] = useState({});
  const [fieldCount, handleFieldCount] = useState(0);
  const [canSubmit, handleCanSubmit] = useState(false);

  const [emailStatus, handleEmailStatus] = useState({
    status: true,
    message: '',
  });

  useEffect(() => {
    async function checkEmail() {
      setLoading(true);
      handleLoading(true);

      const res = await verifyEmail({ email: value });
      delete res.data;
      if (res.status) {
        handleFormType(2);
      } else {
        handleEmailStatus(res);
        handleCanSubmit(false);
      }

      setLoading(false);
      handleLoading(false);
    }

    if (canSubmit && fieldCount >= TOTAL_FIELD && !Object.keys(hasError).length) {
      checkEmail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canSubmit, fieldCount, hasError]);

  function updateField(name, value) {
    handleCanSubmit(false);
    handleDataObj(state => ({ ...state, [name]: value }));
  }

  function handleError({ name, value }) {
    const errors = { ...hasError };

    if (!isFormPristine) {
      handleFieldCount(state => (state === TOTAL_FIELD ? TOTAL_FIELD : state + 1));
    }
    if (value) {
      errors[name] = 'error';
    } else {
      delete errors[name];
    }

    handleHasError(errors);
  }

  function handleFormChange() {
    if (isFormPristine) {
      handleFormPristine(false);
    }
    handleCanSubmit(true);
  }

  const { status, message } = emailStatus;

  return (
    <>
      {!status && <FormAlert message={message} />}
      <Input
        type="email"
        name="email"
        initialValue={value}
        placeholder="Email your email address..."
        validations={[
          {
            validation: /(.*[A-Za-z0-9]){1}/i,
            message: 'Please enter email address',
          },
          {
            validation:
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: 'Invalid Email',
          },
        ]}
        pristine={isFormPristine}
        onChange={value => updateField('email', value)}
        onError={errorValue => handleError(errorValue)}
      />

      <Button
        className={cx(sty['edit-actions'], { 'edit-actions': loading })}
        type={1}
        colorType={2}
        label={loading ? 'Loading...' : 'Register'}
        handleClickNext={handleFormChange}
      />
    </>
  );
}

EmailForm.propTypes = {
  handleFormType: PropTypes.func,
  handleDataObj: PropTypes.func,
  setLoading: PropTypes.func,
  value: PropTypes.string,
};
